// extracted by mini-css-extract-plugin
export default {"form":"styles_form__8p56M","typeRow":"styles_typeRow__q15Hs","inputError":"styles_inputError__9XLpj"};